module.exports = __webpack_public_path__ + "static/media/plus.423c2b98.svg";